import { Provider } from './../../../models/Entities/Provider/Provider';
import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';

// stores
import * as ProviderStore from '../../../redux/middleware/ProviderMiddleware';
import * as ProviderInboxStore from '../../../redux/middleware/ProviderInbox.Middleware';
import {
  ProviderInboxIdentifyResult,
  ProviderInboxResolveRequest,
  ProviderInboxResolveResult,
} from '../../../models/Entities/ProviderInbox/ProviderInbox';


//#region Props

interface IProps {}

interface ConnectedProps {
  isLoadingAll: boolean;
  isUpdatingAll: boolean;
  isUpdatedAll: boolean;
  isLoadedAll: boolean;
  failOnLoadingAll: boolean;
  failOnUpdatingAll: boolean;
  isDeletingOne: boolean;
  isDeletedOne: boolean;
  failOnDeletingOne: boolean;
  error: ErrorType | undefined;
  Providers: Provider[];
}

interface ProvidersDispatchProps {
  GetAllProviders: typeof ProviderStore.actionCreators.GetAllProviders;
  // ---- alta desde factura (spec 009, US4): thunks con promesas, rechazan con ErrorType ----
  IdentifyProviderInvoice: (file: File) => Promise<ProviderInboxIdentifyResult>;
  ResolveProviderInbox: (inboxId: string, body: ProviderInboxResolveRequest) => Promise<ProviderInboxResolveResult>;
  DiscardProviderInbox: (inboxId: string) => Promise<void>;
}

export type Props = IProps & ConnectedProps & ProvidersDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isLoadingAll: state.Provider?.isLoadingAll,
  isUpdatingAll: state.Provider?.isUpdatingAll,
  isUpdatedAll: state.Provider?.UpdatingAllSuccess,
  isLoadedAll: state.Provider?.successLoadingAll,
  failOnLoadingAll: state.Provider?.failOnLoadingAll,
  failOnUpdatingAll: state.Provider?.FailUpdatingAll,
  isDeletingOne: state.Provider?.isDeletingOne,
  isDeletedOne: state.Provider?.successDeletingOne,
  failOnDeletingOne: state.Provider?.failOnDeletingOne,
  error: state.Provider?.error,
  // El orden lo decide la grilla (columna elegida por el usuario); acá no se ordena para no mutar el store.
  Providers: state.Provider?.list ?? []
});

export const mapDispatchToProps = {
  ...ProviderStore.actionCreators,
  ...ProviderInboxStore.actionCreators
};

//#endregion Props
